

import React, { useEffect, useState } from "react";
import { getMyNews, deleteNews } from "../../../services/reporterService";
import {
  CircularProgress,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Pagination,
  Stack,
  Select,
  MenuItem,
} from "@mui/material";

import {


 

  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemIcon
} from "@mui/material";
import { Chip, Divider, Card, CardContent } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
const MyNews = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  // modal state
  const [open, setOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);

  // delete confirm modal
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  // pagination state
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // fetch news
  const fetchMyNews = async (pageNumber = page) => {
    try {
      setLoading(true);
      const response = await getMyNews({ page: pageNumber, limit });
      setNews(response.data || []);
      setTotalPages(response.totalPages || 1);
      setPage(pageNumber);
    } catch (error) {
      console.error("Failed to load my news:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMyNews();
  }, [limit]);

  const handleOpen = (item) => {
    setSelectedNews(item);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedNews(null);
  };

  const handleDeleteClick = (item) => {
    setSelectedNews(item);
    setDeleteConfirmOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!selectedNews) return;
    try {
      setDeleting(true);
      await deleteNews(selectedNews._id);
      setDeleteConfirmOpen(false);
      setOpen(false);
      fetchMyNews(page); // refresh current page
    } catch (error) {
      console.error("Failed to delete news:", error);
    } finally {
      setDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmOpen(false);
    setSelectedNews(null);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center mt-10">
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="p-4">
      <Typography variant="h5" gutterBottom>
        My News
      </Typography>

      {news.length === 0 ? (
        <Typography>No news found.</Typography>
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                
                  <TableCell></TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Sub Category</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {news.map((item) => (
                  <TableRow key={item._id}>
               <TableCell>
  {item.media && item.media.length > 0 ? (
    <img
      src={item.media[0].url}
      alt={item.media[0].caption || "News image"}
      style={{
        width: "70px",
        maxHeight: "70px",
        objectFit: "contain",
        borderRadius: "8px",
        marginBottom: "16px",
        backgroundColor: "#f0fdf9ff",
      }}
    />
  ) : (
    <Typography variant="caption" color="textSecondary">
      No Image
    </Typography>
  )}
</TableCell>

                    
                    <TableCell dangerouslySetInnerHTML={{ __html: item.title_hi || item.title_en }} />
                    <TableCell>{item.category?.name || "-"}</TableCell>
                    <TableCell>{item.subCategory?.name || "-"}</TableCell>
                    <TableCell>{item.status}</TableCell>
                    <TableCell>
                      {item.createdAtDate} {item.createdAtTime}
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleOpen(item)}
                        sx={{ mr: 1 }}
                      >
                        View
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        color="error"
                        onClick={() => handleDeleteClick(item)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination Controls */}
          <Stack spacing={2} sx={{ mt: 2 }} alignItems="center">
            <Pagination
              count={totalPages}
              page={page}
              onChange={(e, value) => fetchMyNews(value)}
              color="primary"
            />
            <Select
              value={limit}
              onChange={(e) => {
                setLimit(e.target.value);
                fetchMyNews(1);
              }}
            >
              {[5, 10, 20, 50].map((l) => (
                <MenuItem key={l} value={l}>
                  {l} per page
                </MenuItem>
              ))}
            </Select>
          </Stack>
        </>
      )}

      {/* Popup Modal for Details */}
      {/* <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle>{selectedNews?.title}</DialogTitle>
        <DialogContent dividers>
          {selectedNews?.media && selectedNews?.media.length > 0 && (
            <img
              src={selectedNews.media[0].url}
              alt={selectedNews.media[0].caption || "News image"}
              style={{
                width: "100%",
                maxHeight: "300px",
                objectFit: "contain",
                borderRadius: "8px",
                marginBottom: "16px",
                backgroundColor: "#f0fdf9ff",
              }}
            />
          )}

          <Typography variant="subtitle1" gutterBottom>
            <strong>Category:</strong> {selectedNews?.category?.name || "-"}
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            <strong>Sub Category:</strong> {selectedNews?.subCategory?.name || "-"}
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            <strong>Status:</strong> {selectedNews?.status}
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            <strong>Country:</strong> {selectedNews?.country?.name || "-"}
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            <strong>State:</strong> {selectedNews?.state?.name || "-"}
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            <strong>City:</strong> {selectedNews?.city?.name || "-"}
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            <strong>Local Address:</strong> {selectedNews?.localAddress || "-"}
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            <strong>Reporter:</strong> {selectedNews?.createdBy?.name || "-"} / (
            {selectedNews?.createdBy?.email})
          </Typography>
          <Typography variant="subtitle2" gutterBottom>
            <strong>Posted Date:</strong> {selectedNews?.postedDate}{" "}
            {selectedNews?.postedTime}
          </Typography>
          <Typography variant="subtitle2" gutterBottom>
            <strong>Last Updated:</strong> {selectedNews?.updatedAtDate}{" "}
            {selectedNews?.updatedAtTime}
          </Typography>
          <Typography variant="body1" sx={{ mt: 2, whiteSpace: "pre-line" }}>
            <strong>Content:</strong>
            <br />
            {selectedNews?.content || "No content available"}
          </Typography>
          {selectedNews?.tags?.length > 0 && (
            <Typography variant="subtitle1" sx={{ mt: 2 }}>
              <strong>Tags:</strong> {selectedNews.tags.join(", ")}
            </Typography>
          )}
          <Typography variant="subtitle2" sx={{ mt: 2 }}>
            <strong>Views:</strong> {selectedNews?.viewsCount || 0}
          </Typography>
          <Typography variant="subtitle2">
            <strong>Likes:</strong> {selectedNews?.likesCount || 0}
          </Typography>
          <Typography variant="subtitle2">
            <strong>Comments:</strong> {selectedNews?.commentsCount || 0}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="primary">
            Close
          </Button>
          <Button
            onClick={() => handleDeleteClick(selectedNews)}
            variant="contained"
            color="error"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog> */}
<Dialog
  open={open}
  onClose={handleClose}
  fullWidth
  maxWidth="lg"
  scroll="paper"
>
  <DialogTitle>News Details</DialogTitle>

  <DialogContent
    dividers
    sx={{
      maxHeight: "70vh",
      overflowY: "auto",
    }}
  >

    {/* Image */}
    {selectedNews?.media?.length > 0 && (
      <Box sx={{ mb: 2 }}>
        <img
          src={selectedNews.media[0].url}
          alt={selectedNews.media[0].caption || "News image"}
          style={{
            width: "100%",
            maxHeight: "300px",
            objectFit: "contain",
            borderRadius: "8px",
            background: "#f5f5f5"
          }}
        />
      </Box>
    )}

    <Grid container spacing={2}>

      <Grid item xs={12}>
        <Typography variant="h6">
          <strong>Title (English): </strong>
          {selectedNews?.title_en || "-"}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h6">
          <strong>शीर्षक (हिंदी): </strong>
          <span
            dangerouslySetInnerHTML={{
              __html: selectedNews?.title_hi || "-"
            }}
          />
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography>
          <strong>Summary (English): </strong>
          {selectedNews?.summary_en || "-"}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography>
          <strong>सारांश (हिंदी): </strong>
          {selectedNews?.summary_hi || "-"}
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <Typography>
          <strong>Category:</strong> {selectedNews?.category?.name || "-"}
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <Typography>
          <strong>Sub Category:</strong> {selectedNews?.subCategory?.name || "-"}
        </Typography>
      </Grid>

      {selectedNews?.subSubCategory && (
        <Grid item xs={6}>
          <Typography>
            <strong>Sub-Sub Category:</strong> {selectedNews.subSubCategory}
          </Typography>
        </Grid>
      )}

      <Grid item xs={6}>
        <Typography>
          <strong>Status:</strong> {selectedNews?.status}
        </Typography>
      </Grid>

      <Grid item xs={4}>
        <Typography>
          <strong>Country:</strong> {selectedNews?.country?.name || "-"}
        </Typography>
      </Grid>

      <Grid item xs={4}>
        <Typography>
          <strong>State:</strong> {selectedNews?.state?.name || "-"}
        </Typography>
      </Grid>

      <Grid item xs={4}>
        <Typography>
          <strong>City:</strong> {selectedNews?.city?.name || "-"}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography>
          <strong>Local Address:</strong> {selectedNews?.localAddress || "-"}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography>
          <strong>Reporter:</strong>{" "}
          {selectedNews?.createdBy?.name || "-"} ({selectedNews?.createdBy?.email})
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <Typography>
          <strong>Posted Date:</strong>{" "}
          {selectedNews?.postedDate || "N/A"} {selectedNews?.postedTime || ""}
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <Typography>
          <strong>Last Updated:</strong>{" "}
          {selectedNews?.updatedAtDate} {selectedNews?.updatedAtTime}
        </Typography>
      </Grid>

    </Grid>


    {/* Content English */}
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6">
        <strong>Content (English)</strong>
      </Typography>

      <Box
        dangerouslySetInnerHTML={{
          __html: selectedNews?.content_en || "No English content available"
        }}
      />
    </Box>


    {/* Content Hindi */}
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6">
        <strong>सामग्री (हिंदी)</strong>
      </Typography>

      <Box
        dangerouslySetInnerHTML={{
          __html: selectedNews?.content_hi || "कोई हिंदी सामग्री उपलब्ध नहीं है"
        }}
      />
    </Box>


    {/* Tags */}
    {selectedNews?.tags?.length > 0 && (
      <Box sx={{ mt: 2 }}>
        <Typography>
          <strong>Tags:</strong> {selectedNews.tags.join(", ")}
        </Typography>
      </Box>
    )}


    {/* Reference Links */}
    {selectedNews?.referenceLinks?.length > 0 && (
      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">Reference Links</Typography>

        <List dense>
          {selectedNews.referenceLinks.map((link, index) => (
            <ListItem key={index}>
              <ListItemText
                primary={
                  <a
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ wordBreak: "break-all" }}
                  >
                    {link}
                  </a>
                }
              />
            </ListItem>
          ))}
        </List>
      </Box>
    )}


    {/* PDF Files */}
    {selectedNews?.pdfFiles?.length > 0 && (
      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">PDF Files</Typography>

        <List dense>
          {selectedNews.pdfFiles.map((pdf, index) => (
            <ListItem key={pdf._id || index}>
              <ListItemIcon>
                <PictureAsPdfIcon />
              </ListItemIcon>

              <ListItemText
                primary={
                  <a
                    href={pdf.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ wordBreak: "break-all" }}
                  >
                    {pdf.originalName || pdf.url.split("/").pop()}
                  </a>
                }
              />
            </ListItem>
          ))}
        </List>
      </Box>
    )}


    {/* Stats */}
    <Box sx={{ mt: 3 }}>
      <Typography>
        <strong>Views:</strong> {selectedNews?.viewsCount || 0}
      </Typography>

      <Typography>
        <strong>Likes:</strong> {selectedNews?.likesCount || 0}
      </Typography>

      <Typography>
        <strong>Comments:</strong> {selectedNews?.commentsCount || 0}
      </Typography>
    </Box>

  </DialogContent>

  <DialogActions>
    <Button onClick={handleClose} variant="contained">
      Close
    </Button>

    <Button
      onClick={() => handleDeleteClick(selectedNews)}
      variant="contained"
      color="error"
    >
      Delete
    </Button>
  </DialogActions>

</Dialog>
       

      {/* Delete Confirm Modal */}
      <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent dividers>
          Are you sure you want to delete this news?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} disabled={deleting}>
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            color="error"
            variant="contained"
            disabled={deleting}
          >
            {deleting ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MyNews;

